"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Exclamation = function Exclamation(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("path", {
    d: "M12.5 19.4012C12.8596 19.4012 13.151 19.1097 13.151 18.7502C13.151 18.3906 12.8596 18.0991 12.5 18.0991C12.1404 18.0991 11.849 18.3906 11.849 18.7502C11.849 19.1097 12.1404 19.4012 12.5 19.4012Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M12.5 16.1459C12.3619 16.1459 12.2294 16.091 12.1317 15.9934C12.034 15.8957 11.9792 15.7632 11.9792 15.6251V6.25008C11.9792 6.11195 12.034 5.97947 12.1317 5.8818C12.2294 5.78412 12.3619 5.72925 12.5 5.72925C12.6381 5.72925 12.7706 5.78412 12.8683 5.8818C12.966 5.97947 13.0208 6.11195 13.0208 6.25008V15.6251C13.0208 15.7632 12.966 15.8957 12.8683 15.9934C12.7706 16.091 12.6381 16.1459 12.5 16.1459Z",
    fill: props.foregroundColor
  }));
};

Exclamation.defaultProps = {
  altText: "Exclamation",
  foregroundColor: "#2D5AB4"
};
Exclamation.propTypes = {
  altText: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Exclamation;
exports.default = _default;